/**
 * Homey Admin V2 API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NotificationSendStatusValue } from './notification-send-status-value';


export interface NotificationSendStatusDto { 
    channel: NotificationSendStatusDto.ChannelEnum;
    sendStatus: NotificationSendStatusValue;
    processDate?: string;
    failureReason?: string;
    notNeededReason?: string;
}
export namespace NotificationSendStatusDto {
    export const ChannelEnum = {
        email: 'email',
        push: 'push',
        text: 'text'
    } as const;
    export type ChannelEnum = typeof ChannelEnum[keyof typeof ChannelEnum];
}


